import { EmptyState, ErrorState, Progress, Skeleton, Spinner } from "@maeiz/ui";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function AsyncPage() {
    return (
        <DocPage
            title="Loading / Empty / Error"
            description="System-level async patterns — never leave a blank region."
        >
            <Section title="Progress">
                <Demo className="grid max-w-lg gap-4">
                    <Progress value={64} label="Sync" />
                    <Progress value={28} label="Upload" tone="gold" size="sm" />
                    <Progress value={82} label="Settlement" tone="success" size="lg" />
                    <Progress value={45} label="Retries" tone="warning" />
                    <Progress value={12} label="Failed batch" tone="danger" />
                </Demo>
            </Section>
            <Section title="Loading & empty">
                <Demo className="grid gap-4 sm:grid-cols-2">
                    <div className="flex items-center gap-3">
                        <Spinner />
                        <Spinner size="sm" />
                    </div>
                    <div className="space-y-2">
                        <Skeleton height={16} />
                        <Skeleton height={16} width="80%" />
                        <Skeleton variant="rectangular" height={80} />
                    </div>
                    <EmptyState
                        title="No deliveries yet"
                        description="Record the first visit for this shift."
                        actionLabel="Add delivery"
                        onAction={() => undefined}
                    />
                    <ErrorState onRetry={() => undefined} />
                </Demo>
            </Section>
            <Section title="Mapping">
                <SpecTable
                    rows={[
                        ["Page loading", "Centered Spinner or skeleton layout"],
                        ["Table loading", "Table isLoading"],
                        ["First-use empty", "EmptyState + primary CTA"],
                        ["Progress", "tone primary/gold/success/warning/danger"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
